import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './executor-current-account.component.scss';
import { ProvincialCityService } from "../../components-wpbbsa/sa-provincial-city/sa-provincial-city.service";
var ExecutorCurrentAccount = /** @class */ (function (_super) {
    tslib_1.__extends(ExecutorCurrentAccount, _super);
    function ExecutorCurrentAccount(element) {
        return _super.call(this, element) || this;
    }
    ExecutorCurrentAccount.prototype.init = function () {
        this.form = this.element.querySelector("form");
        this.submitBtn = Array.from(this.element.querySelectorAll(".js-apply-now__button-business_dfc"));
        this.businessType = this.element.querySelector(".js-business-type");
        this.helpDropDown = this.element.querySelector(".js-enquiry-type");
        this.showMoreBtn = this.element.querySelector('.data-privacy-collapse-show');
        this.showLessBtn = this.element.querySelector('.data-privacy-collapse-hide');
        this.dataPrivacyDetailArea = this.element.querySelector('.data-privacy-detail');
        this.dataSharingGroupHideBtn = this.element.querySelector('.data-sharing-group-hide-btn');
        this.dataSharingGroupShowBtn = this.element.querySelector('.data-sharing-group-show-btn');
        this.dataSharingGroupTextArea = this.element.querySelector('.data-sharing-group');
        this.dataSharing3rdPartyShowBtn = this.element.querySelector('.data-sharing-3rd-party-show-btn');
        this.dataSharing3rdPartyHideBtn = this.element.querySelector('.data-sharing-3rd-party-hide-btn');
        this.dataSharing3rdPartyTextArea = this.element.querySelector('.data-sharing-3rd-party');
        this.dataSharingBoardersHideBtn = this.element.querySelector('.data-sharing-boarders-hide-btn');
        this.dataSharingBoardersShowBtn = this.element.querySelector('.data-sharing-boarders-show-btn');
        this.dataSharingBoardersTextArea = this.element.querySelector('.data-sharing-boarders');
        this.closeButton = this.element.querySelector('.js-apply-now-modal-close');
        if (this.helpDropDown) {
            this.displayEnquiryForm(this.helpDropDown.value);
        }
        this.provincialCityService = ProvincialCityService.getInstance();
        this.addCityAndProvinceFields();
        this.showProvinceAndCitySelection();
    };
    ExecutorCurrentAccount.prototype.bindEvents = function () {
        var _this = this;
        this.submitBtn.map(function (item) { return item.addEventListener("click", function (event) {
            var _button = event.target;
            var _form = _button.closest("form");
            var formFields = _form.querySelectorAll("input, select");
            _this.validationService.validate(formFields);
            var valid = Array.from(_form.querySelectorAll(".form__group--error"));
            if (valid.length === 0) {
                _this.submitForm(_form);
            }
        }); });
        if (this.closeButton) {
            this.closeButton.addEventListener('click', function (event) { return window.location.href = '/southafrica/business/products-and-services/bank-with-us/trust-accounts/executor-current-account'; });
        }
        this.showLessBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showLessBtn.setAttribute('hidden', 'true');
            _this.showMoreBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.setAttribute('hidden', 'true');
        });
        this.showMoreBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.showMoreBtn.setAttribute('hidden', 'true');
            _this.showLessBtn.removeAttribute('hidden');
            _this.dataPrivacyDetailArea.removeAttribute('hidden');
        });
        this.dataSharingGroupHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.setAttribute('hidden', 'true');
            _this.dataSharingGroupHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingGroupShowBtn.removeAttribute('hidden');
        });
        this.dataSharingGroupShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingGroupTextArea.removeAttribute('hidden');
            _this.dataSharingGroupHideBtn.removeAttribute('hidden');
            _this.dataSharingGroupShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.setAttribute('hidden', 'true');
            _this.dataSharing3rdPartyShowBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.setAttribute('hidden', 'true');
        });
        this.dataSharing3rdPartyShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharing3rdPartyTextArea.removeAttribute('hidden');
            _this.dataSharing3rdPartyHideBtn.removeAttribute('hidden');
            _this.dataSharing3rdPartyShowBtn.setAttribute('hidden', 'true');
        });
        this.dataSharingBoardersShowBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.removeAttribute('hidden');
            _this.dataSharingBoardersShowBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.removeAttribute('hidden');
        });
        this.dataSharingBoardersHideBtn.addEventListener('click', function (e) {
            e.preventDefault();
            _this.dataSharingBoardersTextArea.setAttribute('hidden', 'true');
            _this.dataSharingBoardersHideBtn.setAttribute('hidden', 'true');
            _this.dataSharingBoardersShowBtn.removeAttribute('hidden');
        });
        if (this.businessType) {
            this.businessType.addEventListener("change", function () { return _this.validateBusinessType("validate"); });
        }
        if (this.helpDropDown) {
            this.helpDropDown.addEventListener("change", function () {
                _this.displayEnquiryForm(_this.helpDropDown.value);
                _this.showProvinceAndCitySelection();
            });
        }
        if (this.form) {
            var _formFields = Array.from(this.form.querySelectorAll("input, select, textarea"));
            if (_formFields) {
                _formFields.forEach(function (pElement) {
                    pElement.addEventListener("blur", function (pEvent) {
                        _this.validationService.validateBlur(pEvent.currentTarget);
                    });
                });
            }
        }
        // Reset the form
        this.form.addEventListener("custom_form_reset_event", function (pEvent) {
            _this.resetForm();
        }, false);
        var provinceSelect = this.form.querySelector("select[name=province]");
        if (provinceSelect) {
            provinceSelect.addEventListener("change", function (event) {
                _this.populateCities(provinceSelect.value);
            });
            this.populateProvinces();
        }
    };
    ExecutorCurrentAccount.prototype.validateBusinessType = function (type) {
        var _this = this;
        // Business Reg Validations
        function dfcBusinessFormatBusinessReg(event) {
            var _stringLength = parseFloat(event.length);
            var _newLength = (_stringLength - 1);
            var _check = event.substring(_newLength);
            var reg = new RegExp('^[0-9]+$');
            if (reg.test(_check)) {
                if (event.length === 4) {
                    event = event += '/';
                }
                else if (event.length === 11) {
                    event = event += '/';
                }
                else if (event.length > 14) {
                    event = event.substring(0, 14);
                }
            }
            else {
                return event.substring(0, _newLength);
            }
            return event;
        }
        function dfcBusinessFormatExpression(inputText) {
            var _check = inputText.split('/');
            if (_check.length > 1) {
                var _valid1 = true;
                var _valid2 = true;
                var _valid3 = true;
                if (_check.length === 3) {
                    var _seg1 = new RegExp('^/d{4}$');
                    var _seg2 = new RegExp('^/d{6}$');
                    var _seg3 = new RegExp('^/d{2}$');
                    if (_seg1.test(_check[0])) {
                        _valid1 = false;
                    }
                    if (_seg2.test(_check[1])) {
                        _valid2 = false;
                    }
                    if (_seg3.test(_check[2])) {
                        _valid3 = false;
                    }
                    if (_valid1 && _valid2 && _valid3) {
                        return inputText;
                    }
                    else {
                        return '';
                    }
                }
                else {
                    return '';
                }
            }
            else if (inputText.length >= 12) {
                var _firstcharacters = inputText.substring(0, 4);
                var _secondCharacters = inputText.substring(5, 10);
                var _thirdCharacters = inputText.substring(11, 13);
                return _firstcharacters + '/' + _secondCharacters + '/' + _thirdCharacters;
            }
            return '';
        }
        function deleteContent(event) {
            if ((event.inputType !== "deleteContentBackward") && (event.inputType !== "deleteContentForward")) {
                var reg = event.target.value;
                event.target.value = dfcBusinessFormatBusinessReg(reg);
            }
        }
        function addBlur(event) {
            var reg = event.target.value;
            event.target.value = dfcBusinessFormatExpression(reg);
        }
        this.businessOtherDropdown();
        if ((this.businessType.value === "Private_Company") || (this.businessType.value === "Close_Corporation")) {
            var field = this.form.querySelector("input.form__input--identification");
            if (field) {
                var formGroupItem = field.closest(".form__group");
                formGroupItem.classList.remove("form__group--error");
                var labelItem = formGroupItem.querySelector('label');
                labelItem.innerText = "Business Registration Number";
                var newBusRegField = document.createElement('input');
                newBusRegField.setAttribute("name", "business-reg-number");
                newBusRegField.classList.add("form__input");
                newBusRegField.classList.add("form__input--required");
                newBusRegField.classList.add("form__input--busReg");
                newBusRegField.classList.add("form__input--business-registration");
                newBusRegField.placeholder = "Enter your business registration number";
                // This adds slashes to the business registration number
                newBusRegField.addEventListener("input", deleteContent);
                newBusRegField.addEventListener("blur", addBlur);
                newBusRegField.addEventListener("blur", function (pEvent) {
                    _this.validationService.validateBlur(pEvent.currentTarget);
                });
                field.parentNode.replaceChild(newBusRegField, field);
            }
        }
        else {
            // This removes event listener
            var field = this.form.querySelector("input.form__input--business-registration");
            if (field) {
                var formGroupItem = field.closest(".form__group");
                formGroupItem.classList.remove("form__group--error");
                var labelItem = formGroupItem.querySelector('label');
                labelItem.innerText = "ID Number";
                var newIdField = document.createElement('input');
                newIdField.setAttribute("name", "id-number");
                newIdField.setAttribute("maxlength", "13");
                newIdField.classList.add("form__input");
                newIdField.classList.add("form__input--required");
                newIdField.classList.add("form__input--identification");
                newIdField.placeholder = "Enter your South African ID number";
                newIdField.addEventListener("blur", function (pEvent) {
                    _this.validationService.validateBlur(pEvent.currentTarget);
                });
                field.parentNode.replaceChild(newIdField, field);
            }
        }
    };
    ExecutorCurrentAccount.prototype.businessOtherDropdown = function () {
        var field = this.businessType;
        var formGroup = field.closest(".form__group");
        var formGroups = Array.from(this.element.querySelectorAll(".form__group"));
        var formNote = this.element.querySelector(".apply-now__note");
        var formButtons = this.element.querySelector(".apply-now__buttons");
        var formOtherContainer = this.element.querySelector(".form__business-other--container");
        if (this.businessType.value === "OtherContent") {
            formGroups.map(function (item) {
                item.classList.add("form__group--hidden");
            });
            formNote.classList.add("hidden");
            formButtons.classList.add("hidden");
            formOtherContainer.classList.add("active");
        }
        else {
            formGroups.map(function (item) {
                item.classList.remove("form__group--hidden");
            });
            formNote.classList.remove("hidden");
            formButtons.classList.remove("hidden");
            formOtherContainer.classList.remove("active");
            this.showProvinceAndCitySelection();
        }
        formGroup.classList.remove("form__group--hidden");
    };
    ExecutorCurrentAccount.prototype.displayEnquiryForm = function (select) {
        var _tmpType = this.businessType.closest(".form__group");
        var __tmpId = this.element.querySelector("input[name=id-number]");
        var _tmpId = "";
        if (__tmpId) {
            _tmpId = __tmpId.closest(".form__group");
        }
        var __tmpBusiness = this.element.querySelector("input[name=business-reg-number]");
        if (__tmpBusiness) {
            _tmpId = __tmpBusiness.closest(".form__group");
        }
        var __tmpCustomer = this.element.querySelector("input[name=existing-customer]");
        var _tmpCustomer = "";
        if (__tmpCustomer) {
            _tmpCustomer = __tmpCustomer.closest(".form__group");
        }
        switch (select) {
            case "Enquiry":
                this.businessType.classList.remove("form__input--required");
                //_tmpType.style.display = `none`;
                if (_tmpId !== "") {
                    // _tmpId.style.display = `none`;
                    _tmpId.classList.add("form__group--hidden");
                    _tmpId.querySelector("input").classList.remove("form__input--required");
                }
                if (_tmpCustomer) {
                    _tmpCustomer.classList.add("form__group--hidden");
                    // _tmpCustomer.style.display = `none`;
                }
                this.element.querySelector('select[name=business-type]').parentElement.parentElement.parentElement.classList.add('hidden');
                break;
            case "NewAccount":
                this.businessType.classList.add("form__input--required");
                //_tmpType.style.display = `block`;
                if (_tmpId !== "") {
                    _tmpId.classList.remove("form__group--hidden");
                    // _tmpId.style.display = `block`;
                    _tmpId.querySelector("input").classList.add("form__input--required");
                }
                if (_tmpCustomer) {
                    _tmpCustomer.classList.remove("form__group--hidden");
                    // _tmpCustomer.style.display = `block`;
                }
                this.element.querySelector('select[name=business-type]').parentElement.parentElement.parentElement.classList.remove('hidden');
                break;
        }
    };
    ExecutorCurrentAccount.prototype.submitForm = function (form) {
        var _this = this;
        // success screens
        var loader = form.querySelector(".form__loader--container");
        var thankYou = form.querySelector(".form__thankyou--container");
        var fieldsContainer = form.querySelector(".form__fields--container");
        // fields
        var enquiryType = form.querySelector("select[name=enquiry-type]");
        var popiaConsent = form.querySelector("input[name=popia-consent]");
        if (enquiryType && (enquiryType.value === "Enquiry")) {
            if (popiaConsent) {
                // loader + hide form
                loader.classList.add("active");
                fieldsContainer.classList.add("hidden");
                // variables
                var email = form.querySelector("input[name=email]");
                var recipient = form.querySelector("input[name=recipient]");
                var subject = form.querySelector("input[name=subject]");
                var description = form.querySelector("input[name=description]");
                var firstname = form.querySelector("input[name=first-name]");
                var lastname = form.querySelector("input[name=last-name]");
                var phoneNumber = form.querySelector("input[name=phone-number]");
                var altPhoneNumber = form.querySelector("input[name=alternative-number]");
                var emailAddress = form.querySelector("input[name=email-address]");
                var sbCustomer = form.querySelector("input[name=existing-customer]");
                var _postData = {
                    'email': (email ? email.value : ""),
                    'recipient': (recipient ? recipient.value : ""),
                    'subject': (subject ? subject.value : ""),
                    'product': (description ? description.value : ""),
                    'first-name': (firstname ? firstname.value : ""),
                    'last-name': (lastname ? lastname.value : ""),
                    'formLocation': this.formLocationService.getLocation(),
                    'phone-number': (phoneNumber ? phoneNumber.value : ""),
                    'alternative-number': (altPhoneNumber ? altPhoneNumber.value : ""),
                    'email-address': (emailAddress ? emailAddress.value : ""),
                    'banking-with-standard-bank': ((sbCustomer ? (sbCustomer.checked ? "YES" : "NO") : "")),
                    'popiConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
                    'dataSharingGroup': this.getDataConsentValue(form, 'data-sharing-group'),
                    'dataSharing3rdParty': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
                    'dataSharingBoarders': this.getDataConsentValue(form, 'data-sharing-boarders'),
                };
                var _documents = thankYou.querySelector(".form__thankyou--documents");
                if (_documents) {
                    _documents.style.display = "none";
                }
                // service
                var url_1 = this.baseUrl + "/services/BusinessEnquiryForm.jsp";
                this.formsService.postForm(url_1, this.http.serialiseObject(_postData)).then(function (pResponse) {
                    // service ok
                    loader.classList.remove("active");
                    if (pResponse.data.includes('invalid')) {
                        _this.analyticsService.dtmRecordSiteError("noerrorcode | invalid fields | " + url_1);
                        fieldsContainer.classList.remove("hidden");
                    }
                    else {
                        _this.analyticsService.dtmFormComplete("complete", "");
                        loader.classList.remove("active");
                        thankYou.classList.add("active");
                    }
                }).catch(function (pError) {
                    // service failed
                    _this.analyticsService.dtmRecordSiteError("noerrorcode | invalid fields | " + url_1);
                    loader.classList.remove("active");
                    thankYou.classList.add("active");
                });
            }
            else {
                // loader + hide form
                loader.classList.add("active");
                fieldsContainer.classList.add("hidden");
                // variables
                var email = form.querySelector("input[name=email]");
                var recipient = form.querySelector("input[name=recipient]");
                var subject = form.querySelector("input[name=subject]");
                var description = form.querySelector("input[name=description]");
                var firstname = form.querySelector("input[name=first-name]");
                var lastname = form.querySelector("input[name=last-name]");
                var phoneNumber = form.querySelector("input[name=phone-number]");
                var altPhoneNumber = form.querySelector("input[name=alternative-number]");
                var emailAddress = form.querySelector("input[name=email-address]");
                var sbCustomer = form.querySelector("input[name=existing-customer]");
                var _postData = {
                    'email': (email ? email.value : ""),
                    'recipient': (recipient ? recipient.value : ""),
                    'subject': (subject ? subject.value : ""),
                    'description': (description ? description.value : ""),
                    'firstname': (firstname ? firstname.value : ""),
                    'surname': (lastname ? lastname.value : ""),
                    'formLocation': this.formLocationService.getLocation(),
                    'contactNo': (phoneNumber ? phoneNumber.value : ""),
                    'AltContactNo': (altPhoneNumber ? altPhoneNumber.value : ""),
                    'email-address': (emailAddress ? emailAddress.value : ""),
                    'banking-with-standard-bank': ((sbCustomer ? (sbCustomer.checked ? "YES" : "NO") : "")),
                    'popiConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
                    'source': this.formsService.isMobile()
                };
                var _documents = thankYou.querySelector(".form__thankyou--documents");
                if (_documents) {
                    _documents.style.display = "none";
                }
                // service
                var url_2 = this.baseUrl + "/services/genericform.jsp";
                this.formsService.postForm(url_2, this.http.serialiseObject(_postData)).then(function (pResponse) {
                    // service ok
                    loader.classList.remove("active");
                    if (pResponse.data.includes('invalid')) {
                        _this.analyticsService.dtmRecordSiteError("noerrorcode | invalid fields | " + url_2);
                        fieldsContainer.classList.remove("hidden");
                    }
                    else {
                        _this.analyticsService.dtmRecordSiteError("noerrorcode | invalid fields | " + url_2);
                        loader.classList.remove("active");
                        thankYou.classList.add("active");
                        _this.dtmVirtualPage('thank you');
                    }
                }).catch(function (pError) {
                    // service failed
                    _this.analyticsService.dtmFormComplete("complete", "");
                    loader.classList.remove("active");
                    thankYou.classList.add("active");
                });
            }
        }
        else {
            // loader + hide form
            loader.classList.add("active");
            fieldsContainer.classList.add("hidden");
            // variables
            var email = form.querySelector("input[name=email]");
            var recipient = form.querySelector("input[name=recipient]");
            var subject = form.querySelector("input[name=subject]");
            var description = form.querySelector("input[name=description]");
            var firstname = form.querySelector("input[name=first-name]");
            var lastname = form.querySelector("input[name=last-name]");
            var businessType = form.querySelector("select[name=business-type]");
            var businessName = form.querySelector("input[name=business-name]");
            var phoneNumber = form.querySelector("input[name=phone-number]");
            var altPhoneNumber = form.querySelector("input[name=alternative-number]");
            var emailAddress = form.querySelector("input[name=email-address]");
            var businessRegNumber = form.querySelector("input[name=business-reg-number]");
            var idnumber = form.querySelector("input[name=id-number]");
            var province = form.querySelector("select[name=province]");
            var city = form.querySelector("select[name=city]");
            var existingCustomer = form.querySelector("input[name=existing-customer]");
            var _postData = {
                'email': (email ? email.value : ""),
                'recipient': (recipient ? recipient.value : ""),
                'subject': (subject ? subject.value : ""),
                'description': (description ? description.value : ""),
                'businessDescription': (description ? description.value : ""),
                'firstName': (firstname ? firstname.value : ""),
                'surName': (lastname ? lastname.value : ""),
                'entityType': (businessType ? businessType.value.replace(/_/g, " ") : ""),
                'businessName': (businessName ? businessName.value : ""),
                'contactNumber': (phoneNumber ? phoneNumber.value : ""),
                'altContactNumber': (altPhoneNumber ? altPhoneNumber.value : ""),
                'emailAddress': (emailAddress ? emailAddress.value : ""),
                'formLocation': this.formLocationService.getLocation(),
                'businessRegistrationNum': (businessRegNumber ? businessRegNumber.value : ""),
                'saId': (idnumber ? idnumber.value : ""),
                'province': (province ? province.value : ""),
                'city': (city ? city.value : ""),
                'sbsaUser': ((existingCustomer ? (existingCustomer.checked ? "YES" : "NO") : "")),
                'popiConsent': ((popiaConsent ? (popiaConsent.checked ? "YES" : "NO") : "NO")),
                'source': this.formsService.isMobile(),
                'dataSharingWithinOurGrpMarketingConsent': this.getDataConsentValue(form, 'data-sharing-group'),
                'dataSharingWithThirdPartiesMarketingConsent': this.getDataConsentValue(form, 'data-sharing-3rd-party'),
                'dataSharingAcrossBordersWithinOurGrpMarketingConsent': this.getDataConsentValue(form, 'data-sharing-boarders'),
            };
            // service
            var url_3 = this.baseUrl + '/bcleadUtils/edbusiness';
            var _config = {
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'X-Requested-With': 'XMLHttpRequest'
                }
            };
            this.formsService.postForm(url_3, _postData, _config).then(function (pResponse) {
                // service ok
                loader.classList.remove("active");
                if (pResponse.data && pResponse.data === "invalid") {
                    _this.analyticsService.dtmRecordSiteError("noerrorcode | invalid fields | " + url_3);
                    fieldsContainer.classList.remove("hidden");
                }
                else {
                    _this.analyticsService.dtmFormComplete("complete", pResponse.data);
                    thankYou.classList.add("active");
                    _this.dtmVirtualPage('thank you');
                    var _documents = thankYou.querySelector(".form__thankyou--documents");
                    var responseRef = pResponse.data.trim();
                    if (_documents) {
                        _documents.removeAttribute("style");
                        var _buttonContainer = _documents.querySelector(".form__thank--documents-button");
                        var _subject = "My Reference Number Is: " + responseRef;
                        var _body = "To Whom It May Concern\n\nAttached please find a copy of the following documents as requested:\n\nID of owners and signatories\nProof of address not older than 3 months\nCompany registration documents if a registered company";
                        var _mailtoText = "mailto:SmallEnterpriseSales@standardbank.co.za?subject=" + encodeURIComponent(_subject) + "&body=" + encodeURIComponent(_body);
                        var _newButton = document.createElement("a");
                        _newButton.classList.add("button", "button--large", "button--centered", "button--main");
                        _newButton.setAttribute("data-id", "link_content_ documents email click");
                        _newButton.setAttribute("data-text", "email documents button click");
                        _newButton.setAttribute("href", _mailtoText);
                        var _text = document.createTextNode("EMAIL DOCUMENTS");
                        _newButton.appendChild(_text);
                        _buttonContainer.innerHTML = "";
                        _buttonContainer.appendChild(_newButton);
                    }
                }
            }).catch(function (pError) {
                // service failed
                _this.analyticsService.dtmRecordSiteError("noerrorcode | service failure occurred | " + url_3);
                loader.classList.remove("active");
                fieldsContainer.classList.remove("hidden");
            });
        }
    };
    ExecutorCurrentAccount.prototype.getDataConsentValue = function (form, selector) {
        var radioBtn = form.querySelector("input[name=\"" + selector + "\"]:checked");
        if (radioBtn && radioBtn.checked) {
            return radioBtn.value.toUpperCase();
        }
        else {
            return null;
        }
    };
    ExecutorCurrentAccount.prototype.resetForm = function () {
        var _this = this;
        var field = this.form.querySelector("input.form__input--business-registration");
        if (field) {
            var formGroupItem = field.closest(".form__group");
            formGroupItem.classList.remove("form__group--error");
            var labelItem = formGroupItem.querySelector('label');
            labelItem.innerText = "ID Number";
            var newIdField = document.createElement('input');
            newIdField.setAttribute("name", "id-number");
            newIdField.setAttribute("maxlength", "13");
            newIdField.classList.add("form__input");
            newIdField.classList.add("form__input--required");
            newIdField.classList.add("form__input--identification");
            newIdField.placeholder = "Enter your South African ID number";
            newIdField.addEventListener("blur", function (pEvent) {
                _this.validationService.validateBlur(pEvent.currentTarget);
            });
            field.parentNode.replaceChild(newIdField, field);
        }
        if (this.helpDropDown) {
            this.helpDropDown.value = "Enquiry";
            this.displayEnquiryForm(this.helpDropDown.value);
        }
    };
    ExecutorCurrentAccount.prototype.showProvinceAndCitySelection = function () {
        if (this.helpDropDown) {
            if (this.helpDropDown.value === "Enquiry") {
                Array.from(this.form.querySelectorAll(".provincial-city-group")).forEach(function (elm) {
                    elm.classList.add("form__group--hidden");
                });
                return;
            }
        }
        Array.from(this.form.querySelectorAll(".provincial-city-group")).forEach(function (elm) {
            elm.classList.remove("form__group--hidden");
        });
        var province = this.form.querySelector("select[name=province]");
        this.populateCities(province.value);
    };
    ExecutorCurrentAccount.prototype.populateProvinces = function () {
        var provinceSelect = this.form.querySelector("select[name=province]");
        if (provinceSelect) {
            var provinces = this.provincialCityService.getProvices();
            var provinceOption_1 = document.createElement("option");
            provinceOption_1.setAttribute("value", "");
            provinceOption_1.appendChild(document.createTextNode("Please select"));
            provinceSelect.appendChild(provinceOption_1);
            provinces['provinces'].forEach(function (province) {
                provinceOption_1 = document.createElement("option");
                provinceOption_1.setAttribute("value", province["value"]);
                provinceOption_1.appendChild(document.createTextNode(province["name"]));
                provinceSelect.appendChild(provinceOption_1);
            });
        }
    };
    ExecutorCurrentAccount.prototype.populateCities = function (provinceValue) {
        var citySelectWrapper = this.form.querySelector(".city-selection-wrapper");
        if (provinceValue && citySelectWrapper) {
            var cities = this.provincialCityService.getCities(provinceValue);
            // clean up
            var citiesSelect_1 = this.form.querySelector("select[name=city]");
            while (citiesSelect_1.lastChild) {
                var selectOption = citiesSelect_1.lastChild;
                citiesSelect_1.removeChild(citiesSelect_1.lastChild);
            }
            if (cities && cities['cities']) {
                // clear and rebuild cities select options
                var cityOption_1 = document.createElement("option");
                cityOption_1.setAttribute("value", "");
                cityOption_1.appendChild(document.createTextNode("Please select"));
                citiesSelect_1.appendChild(cityOption_1);
                cities['cities'].forEach(function (city) {
                    cityOption_1 = document.createElement("option");
                    cityOption_1.setAttribute("value", city["value"]);
                    cityOption_1.appendChild(document.createTextNode(city["name"]));
                    citiesSelect_1.appendChild(cityOption_1);
                });
                // display cities
                citySelectWrapper.classList.remove("form__group--hidden");
            }
            else {
                citySelectWrapper.classList.add("form__group--hidden");
            }
        }
        else {
            citySelectWrapper.classList.add("form__group--hidden");
        }
    };
    ExecutorCurrentAccount.prototype.addProvinceSelectionField = function () {
        // get email wrapper
        var _emailWrapperDiv = this.form.querySelector("input[name=existing-customer]");
        if (!_emailWrapperDiv) {
            _emailWrapperDiv = this.form.querySelector("input[name=popia-consent]");
        }
        _emailWrapperDiv = _emailWrapperDiv.closest(".form__group");
        // wrapper from mandatory name input field
        var wrapperDiv = document.createElement('div');
        wrapperDiv.classList.add("form__group", "province-selection-wrapper", "js-business-acc-field", "provincial-city-group", "form__group--hidden");
        // select label
        var label = document.createElement('label');
        label.classList.add("form__label");
        label.innerHTML = 'Select Province';
        wrapperDiv.appendChild(label);
        // select div
        var selectDiv = document.createElement('div');
        selectDiv.classList.add("form__select");
        // select
        // input
        var provinceSelectInput = document.createElement('select');
        provinceSelectInput.setAttribute("name", "province");
        provinceSelectInput.classList.add("form__input", "form__input--required", "province-selection");
        selectDiv.appendChild(provinceSelectInput);
        wrapperDiv.appendChild(selectDiv);
        _emailWrapperDiv.parentElement.insertBefore(wrapperDiv, _emailWrapperDiv);
    };
    ExecutorCurrentAccount.prototype.addCitySelectionField = function () {
        // get email wrapper
        var provinceWraperDiv = this.form.querySelector(".province-selection-wrapper");
        // wrapper from mandatory name input field
        var wrapperDiv = document.createElement('div');
        wrapperDiv.classList.add("form__group", "city-selection-wrapper", "js-business-acc-field", "provincial-city-group", "form__group--hidden");
        // select label
        var label = document.createElement('label');
        label.classList.add("form__label");
        label.innerHTML = 'Select City';
        wrapperDiv.appendChild(label);
        // select div
        var selectDiv = document.createElement('div');
        selectDiv.classList.add("form__select");
        // select input
        var citySelectInput = document.createElement('select');
        citySelectInput.setAttribute("name", "city");
        citySelectInput.classList.add("form__input", "form__input--required", "city-selection");
        selectDiv.appendChild(citySelectInput);
        wrapperDiv.appendChild(selectDiv);
        provinceWraperDiv.parentNode.insertBefore(wrapperDiv, provinceWraperDiv.nextSibling);
    };
    ExecutorCurrentAccount.prototype.addCityAndProvinceFields = function () {
        this.addProvinceSelectionField();
        this.addCitySelectionField();
    };
    ExecutorCurrentAccount.prototype.dtmVirtualPage = function (pPageNameNew) {
        var taggingValue = pPageNameNew === 'thank you' ?
            'business:products and services:bank with us:trust accounts:executor current account success thank you'
            : "business:products and services:bank with us:executors current account";
        dataLayer.pageName =
            taggingValue;
        if (typeof _satellite == "object") {
            _satellite.track("globalVirtualPageView");
        }
    };
    return ExecutorCurrentAccount;
}(Base));
export { ExecutorCurrentAccount };



//////////////////
// WEBPACK FOOTER
// ./components/executor-current-account/executor-current-account.component.ts
// module id = 1057
// module chunks = 0